import { render, staticRenderFns } from "./EditorHeaderToggleEdit.vue?vue&type=template&id=6a09df0c&scoped=true"
import script from "./EditorHeaderToggleEdit.vue?vue&type=script&lang=js"
export * from "./EditorHeaderToggleEdit.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderToggleEdit.vue?vue&type=style&index=0&id=6a09df0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09df0c",
  null
  
)

export default component.exports